(() => {
  const ready = (element) => element.classList.add('is-bg-ready');
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          observer.unobserve(entry.target);
          ready(entry.target);
        }
      }, { rootMargin: '600px 0px' })
    : null;
  const watch = (container = document) => {
    container.querySelectorAll('[data-lazy-bg]:not(.is-bg-ready)').forEach((element) => {
      if (observer) observer.observe(element);
      else ready(element);
    });
  };
  watch();
  document.addEventListener('shopify:section:load', (event) => watch(event.target));
})();

